import { Flex } from '@chakra-ui/react'
import productImage from '../../Assets/Product.svg'
import { BrightNess, LightColorName } from '../../Data/Types'
import { AnimatePresence, motion } from 'framer-motion'
import ProductResult from './ProductResult'
import VirtualLinesResults from './VirtualLineResults/VirtualLinesResults'
import VisibilityResults from './VisibilityResults/VisibilityResults'
import RequestAQuote from './RequestAQuoteResults/RequestAQuote'
import { Children } from 'react'

interface ResultProps {
	brightness: BrightNess
	children: React.ReactNode
}

const Result: React.FC<ResultProps> = ({ children, brightness }) => {
	return (
		<AnimatePresence>
			<Flex flexDir={'column'} rowGap={'1rem'}>
				<Flex
					background={'white'}
					transition="all 0.3s ease-in-out"
					as={motion.div}
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					mb="10vh"
					my="1rem"
					borderTop={'solid 1.75rem'}
					borderTopColor={'orange.400'}
					pt={'1.5rem'}
					pb={{ base: '4rem', md: '2rem' }}
					alignSelf={'center'}
					borderRadius={'lg'}
					justifyContent={'center'}
					boxShadow={'dark-lg'}
					flexDir={'column'}
					width={{ base: '88%', md: '85%' }}
					align="center"
					rowGap={{ base: '1.5rem', md: '0' }}
				>
					<Flex
						rowGap={'2rem'}
						columnGap={'1rem'}
						flexWrap="wrap"
						width="100%"
						height={{ md: '20rem' }}
						justifyContent={'space-evenly'}
					>
						<ProductResult
							productImage={productImage}
							productHeader="Virtualine PRO"
							productDescription="HVPG87XXX"
						/>
						{children}
						<VisibilityResults brightness={brightness}></VisibilityResults>
						<RequestAQuote />
					</Flex>
				</Flex>
			</Flex>
		</AnimatePresence>
	)
}

export default Result
